<template>
  <div class="collections container">
    <div v-if="(isindex && title) || !isindex">
      <h1 class="title_font2">{{ title || $t('productList.catalog') }}</h1>
      <v-line></v-line>
    </div>
    <div class="row collectionstop" v-if="catesList.length">
      <!-- {
        只有一条的时候不论大小都为col-12,
        只有2条和4条的时候都为col-6,
        3的倍数时大屏col-4，小屏col-6,
        3的倍数时并且奇数的话第一个小屏要为col-12
        3余1并且总数大于4时第一个大屏6小屏12
        3余1并且总数大于4时前4个不论大小都为6
        3余1并且总数大于4时4以后的大4 小6
        3余2并且总数大于4时第2个不论大小为6
        3余2并且总数大于4时且为奇数时候第一个大6小12
        3余2并且总数大于4时且为偶数时候第一个不论大小都为6
        3余2并且总数大于4时第二个以后大4小6
      } -->
      <div
        v-for="(item, index) in catesList"
        class="collectionstopitem"
        :key="index"
        :class="[
          { 'col-12 only_item': catesListLength == 1 },
          { 'col-6': catesListLength % 2 == 0 && catesListLength <= 4 },
          { 'col-sm-4 col-6': catesListLength % 3 == 0 },
          { 'col-sm-4 col-12': catesListLength % 3 == 0 && catesListLength % 2 == 1 && index == 0 },
          { 'col-sm-6 col-12': catesListLength % 3 == 1 && catesListLength % 2 == 1 && catesListLength > 4 && index == 0 },
          { 'col-6': catesListLength % 3 == 1 && catesListLength % 2 == 0 && catesListLength > 4 && index == 0 },
          { 'col-6': catesListLength % 3 == 1 && catesListLength > 4 && index < 4 },
          { 'col-sm-4 col-6': catesListLength % 3 == 1 && catesListLength > 4 && index >= 4 },
          { 'col-6': catesListLength % 3 == 2 && catesListLength > 4 && index == 1 },
          { 'col-sm-6 col-12': catesListLength % 3 == 2 && catesListLength > 4 && catesListLength % 2 == 1 && index == 0 },
          { 'col-6': catesListLength % 3 == 2 && catesListLength > 4 && catesListLength % 2 == 0 && index == 0 },
          { 'col-sm-4 col-6': catesListLength % 3 == 2 && catesListLength > 4 && index > 1 },
        ]"
      >
        <a :href="'/collections/' + item.term.slug" :class="[themeStyleRadius == 'circle' ? 'image-radius' : '']">
        <div class="collectionstopitem__card">
          <v-lazy-img 
            class="collectionstopitem__img"
            :src="featureImage(item)['thumbnail']"
            :data-url="featureImage(item)['url']"
          />
          <span class="secondary_title">{{ item.term.name }}</span>
        </div>
        </a>
      </div>
      <div class="paging text-center col-12" v-if="cates && cates.last_page > 1 && !isindex">
        <el-pagination
          :pager-count="5"
          :page-size="cates.per_page - 0"
          :current-page="cates.current_page"
          layout="prev, pager, next"
          :total="cates.total"
          @current-change="page"
        ></el-pagination>
      </div>
    </div>
    <div v-else class="page_text_font">{{ $t('home.not_include_content') }}</div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['cates', 'title', 'isindex'],
  data() {
    return {
      catesList: [],
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    }),
    catesListLength() {
      return this.catesList.length
    }
  },
  methods: {
    page(e) {
      window.open(this.replaceSearch('page', e), '_self')
    },
    featureImage(item, field) {
      let { thumbnail, first_product_image } = item

      if (thumbnail && Object.keys(thumbnail).length) {
        return thumbnail;
      } 
      if (first_product_image && Object.keys(first_product_image).length) {
        return first_product_image
      }

      return {}
    },
  },
  watch: {
    cates: {
      handler(newV) {
        if (Array.isArray(newV)) {
          this.catesList = newV
        } else {
          this.catesList = newV.data
        }
      },
      immediate: true,
    },
  },
}
</script>
<style scoped lang='scss'>
.collections {
  margin-top: 80px;
  text-align: center;
  margin-bottom: 50px;
  h1 {
    margin-top: 0px;
    font-size: 26px;
    margin-bottom: 20px;
  }
  hr {
    height: 1px;
    display: block;
    margin: 0px auto 40px !important;
  }
  .collectionstop {
    margin-bottom: -20px;
    .collectionstopitem {
      padding-bottom: 20px;
      padding-left: 10px;
      padding-right: 10px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
        text-decoration: none;
        overflow: hidden;
      }
      &__card {
        height: 310px;
        transition: all 0.8s;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          opacity: 0.25;
          background-color: #000;
          transition: all 0.8s;
          z-index: 1;
        }
        &:hover {
          img {
            transform: scale(1.05);
            &:after {
              opacity: 0.5;
            }
          }
        }
        span {
          width: 100%;
          position: absolute;
          z-index: 2;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 30px;
          font-weight: 400;
          overflow: hidden;
        }
      }
      &__img {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
        z-index: 0;
        object-fit: cover;
        transition: all 0.8s;
      }
    }
    .only_item {
      a {
        div {
          height: 450px;
        }
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .collections {
    .collectionstop {
      .collectionstopitem {
        padding: 0 7.5px 20px;
        &__card {
          height: 190px;
          span {
            padding: 0;
            font-size: 26px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .collections {
    margin-top: 40px;
    margin-bottom: 40px;
    hr {
      margin: 0px auto 20px !important;
    }
    .collectionstop {
      margin-bottom: -10px;
      margin-left: -5px;
      margin-right: -5px;
      & > .collectionstopitem {
        padding: 0 5px 10px;
      }
    }
  }
}
</style>